import React from 'react';
import { withTheme } from 'styled-components';
export var AgriculturaIcon = function AgriculturaIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "246px",
    height: "266px",
    viewBox: "0 0 246 266",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Agricultura"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Agricultura",
    transform: "translate(-61.000000, -1.000000)",
    stroke: theme.colors.primary
  }, React.createElement("g", {
    transform: "translate(49.000000, 6.000000)"
  }, React.createElement("path", {
    d: "M134.97,260.52 L134.97,257.59 C134.97,226.65 147.26,196.98 169.14,175.11",
    id: "Path",
    strokeWidth: "10"
  }), React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: "9.9999041",
    transform: "translate(207.290004, 136.949786) rotate(-45.000000) translate(-207.290004, -136.949786) ",
    cx: "207.290004",
    cy: "136.949786",
    rx: "53.9594825",
    ry: "34.1696723"
  }), React.createElement("path", {
    d: "M134.97,260.52 L134.97,257.59 C134.97,226.65 122.68,196.98 100.8,175.11",
    id: "Path",
    strokeWidth: "10"
  }), React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: "9.9999041",
    transform: "translate(62.649860, 136.946130) rotate(-45.000000) translate(-62.649860, -136.946130) ",
    cx: "62.64986",
    cy: "136.94613",
    rx: "34.1696723",
    ry: "53.9594825"
  }), React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: "10",
    cx: "134.97",
    cy: "54.64",
    rx: "34.17",
    ry: "53.96"
  }), React.createElement("line", {
    x1: "134.97",
    y1: "108.6",
    x2: "134.97",
    y2: "260.52",
    id: "Path",
    strokeWidth: "10"
  })))));
};
export default withTheme(AgriculturaIcon);